"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductsSection = void 0;
var SearchSuggestionClick = _interopRequireWildcard(require("@ori-events/search-suggestion-click"));
var _analyticsData = require("@ori/analytics-data");
var _culture = require("@ori/culture");
var _searchPreviewProduct = require("@ori/search-preview-product");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useTranslations = require("../../../../hooks/useTranslations");
var _utils = require("../../../../utils");
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _styles = require("../../styles");
var _constants2 = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ProductsSection = ({
  title,
  products,
  query,
  showDividerForLastItem
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    financialSet
  } = (0, _culture.useCulture)();
  const {
    sendNavigationSignal
  } = (0, _hooks.useSendNavigationSignal)({
    query
  });
  const getAnalyticsData = (0, _react.useCallback)(position => ({
    placement: _analyticsData.Placement.TopNavigationSearchSuggestions,
    position
  }), []);
  const searchPreviewProductTranslations = (0, _react.useMemo)(() => ({
    quickBuy: translations.quickBuy,
    favorites: translations.favorites
  }), [translations.favorites, translations.quickBuy]);
  const onProductClick = (0, _react.useCallback)((product, position) => async () => {
    const searchSuggestionClickData = {
      itemData: _utils.analytics.formatProduct({
        ...product,
        currencyCode: financialSet?.currencyCode
      }),
      itemType: _analyticsData.ContentType.Product,
      searchQuery: query,
      placement: _analyticsData.Placement.TopNavigationSearchSuggestions,
      position
    };
    window.dispatchEvent(new CustomEvent(SearchSuggestionClick.Name, {
      detail: searchSuggestionClickData
    }));
    await sendNavigationSignal(position);
    (0, _utils.goToPage)((0, _utils.addParamsToUrl)({
      url: (0, _utils.getProductUrl)(product.code),
      params: query ? {
        [_constants.QUERY_NAME]: query
      } : undefined
    }));
  }, [financialSet?.currencyCode, query, sendNavigationSignal]);
  if (products.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Section, {
    "data-testid": getTestId(_constants2.PRODUCTS_LIST_SECTION),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SectionLabel, {
      variant: "caption",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Products, {
      children: products.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_searchPreviewProduct.SearchPreviewProduct, {
          shouldRenderQuickBuyButton: true,
          ...product,
          translations: searchPreviewProductTranslations,
          analyticsData: getAnalyticsData(index),
          searchPhrase: query,
          onProductClick: onProductClick(product, index)
        }, product.code), !showDividerForLastItem && products.length - 1 === index ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledDivider, {})]
      }, product.code))
    })]
  });
};
exports.ProductsSection = ProductsSection;
